import * as React from 'react'
import { E, O, pipe } from '@packages/prelude'
import * as domain from '@packages/domain'

export interface UseHintErrorArgs {
  initialData: O.Option<E.Either<domain.Error.Type, domain.Api.IALoadPreviewResponse.Type>>
}

export interface UseHintErrorResult {
  hintError: O.Option<domain.Error.Type>
  reportError: (error: domain.Error.Type) => void
  onModalHintHide: () => void
}

export const useHintError = ({ initialData }: UseHintErrorArgs): UseHintErrorResult => {
  const [hintError, setHintError] = React.useState<O.Option<domain.Error.Type>>(O.none)

  React.useEffect(() => {
    setHintError(pipe(initialData, O.chain(O.getLeft)))
  }, [initialData])

  // surface a later failure (e.g. a restored recording whose stored URL is gone) through the same modal
  const reportError = React.useCallback((error: domain.Error.Type) => setHintError(O.some(error)), [])

  const onModalHintHide = React.useCallback(() => {
    setHintError(O.none)
    history.replaceState({}, document.title, window.location.pathname)
  }, [])

  return { hintError, reportError, onModalHintHide }
}
